export function upperCaseBegin(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Returns 1 if a > b, 0 if equal and -1 if a < b
 * @param a string
 * @param b string
 */
export function compareStrings(a: string, b: string) {
    if (a === b) {
        return 0;
    }
    return a > b ? 1 : -1;
}

export function getLicenseKey(): string {
    const licenseKey = process.env.REACT_APP_LIC ?? '';

    if (isNullOrWhitespace(licenseKey)) {
        console.error('Invalid settings: Apryse license key not set.');
    }

    return isBase64String(licenseKey) ? window.atob(licenseKey) : licenseKey;
}

export function isNullOrWhitespace(s: string | null | undefined): boolean {
    return !s || !s.trim();
}

export function isBase64String(s: string): [boolean, string] {
    try {
        if (isNullOrWhitespace(s) || s.length % 4 != 0) {
            return [false, ''];
        }

        return [true, window.atob(s)];
    } catch {
        return [false, ''];
    }
}
